import React from "react";
import { Semantics } from "shared/components/drops/DropsBadge";
import { SemanticsIcon } from "shared/components/feedback/InfoMessage/SemanticsIcon";
import {
  COLUMN_GAP,
  InfoMessageBaseStyling,
} from "shared/components/feedback/InfoMessage/style";
import { CloseButton } from "shared/components/Spor";
import { Text } from "shared/components/typography/TitleStyles";
import { ThemeSemantic, useThemeSemantic } from "shared/theme/themeSemantic";
import styled from "styled-components";

const DismissibleMessage = styled.div<{
  themeSemantics: ThemeSemantic;
}>`
  ${({ themeSemantics }) => InfoMessageBaseStyling(themeSemantics)};
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  column-gap: ${COLUMN_GAP}px;
`;

interface InfoMessageProps extends React.HtmlHTMLAttributes<HTMLDivElement> {
  semantics: Semantics;
  summary: string;
  isDismissed: boolean;
  onDismiss: () => void;
}

export const DismissibleInfoMessage = ({
  semantics,
  summary,
  isDismissed,
  onDismiss,
  ...rest
}: InfoMessageProps) => {
  const theme = useThemeSemantic(semantics);
  return isDismissed ? null : (
    <DismissibleMessage themeSemantics={theme} {...rest}>
      <SemanticsIcon semantics={semantics} />
      <Text>{summary}</Text>
      <CloseButton onClick={onDismiss} />
    </DismissibleMessage>
  );
};
